'use strict';
module.exports = (['$filter', 'zonedDateTimeToDateFilter', function ($filter, zonedDateTimeToDateFilter) {
        return function (validityPeriodsArray) {
            var ret = "";
            if (validityPeriodsArray && validityPeriodsArray.length) {
                angular.forEach(validityPeriodsArray, function (period) {
                    //createdDate: (obj.createdDate !== undefined && obj.createdDate !== null) ? $filter('date')(zonedDateTimeToDateFilter(obj.createdDate), "dd/MM/yyyy hh:mm") : "",
                    //dateStart
                    //dateEnd
                    var dateStart = "";
                    var dateEnd = "";
                    if (period.dateStart !== undefined && period.dateStart !== null) {
                        dateStart = $filter('date')(zonedDateTimeToDateFilter(period.dateStart), "dd/MM/yyyy hh:mm");
                    }

                    if (period.dateEnd !== undefined && period.dateEnd !== null) {
                        dateEnd = $filter('date')(zonedDateTimeToDateFilter(period.dateEnd), "dd/MM/yyyy hh:mm");
                    }

                    ret = ret + dateStart + " - " + dateEnd + "; ";
                });
            }

            return ret;
        };
    }]);





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/filters/validityPeriodsToStringFilter.js
// module id = 280
// module chunks = 0